import { isDefined } from "@opendaw/lib-std";
const PREFIX = "opendaw.input-latency.";
const key = (deviceId) => `${PREFIX}${deviceId}`;
export var DeviceLatency;
(function (DeviceLatency) {
    DeviceLatency.save = (deviceId, ms) => localStorage.setItem(key(deviceId), String(ms));
    DeviceLatency.load = (deviceId) => {
        const raw = localStorage.getItem(key(deviceId));
        if (raw === null) {
            return undefined;
        }
        const val = Number(raw);
        return isNaN(val) ? undefined : val;
    };
    DeviceLatency.clear = (deviceId) => localStorage.removeItem(key(deviceId));
    DeviceLatency.list = () => {
        const entries = [];
        for (let index = 0; index < localStorage.length; index++) {
            const storageKey = localStorage.key(index);
            if (storageKey === null || !storageKey.startsWith(PREFIX)) {
                continue;
            }
            const deviceId = storageKey.slice(PREFIX.length);
            const ms = DeviceLatency.load(deviceId);
            if (isDefined(ms)) {
                entries.push({ deviceId, ms });
            }
        }
        return entries;
    };
})(DeviceLatency || (DeviceLatency = {}));
